<script>
/**
 * Needed for input[type=range] styling as pseudo-element
 * rules can't normally be applied dynamically.
 */
import VStyle from '@/utils/VStyle.js';

export default {
  name: 'RangeSetting',
  components: {
    VStyle,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 5,
    },
    value: {
      type: Number,
      default: null,
    },
  },
  data: function() {
    return {
      sentValue: this.value,
      id: 0,
      tooltipTimer: null,
      tooltipHover: false,
    };
  },
  computed: {
    isActive: function() {
      return this.value > 0;
    },
    style: function() {
      const offset = ((50 - this.valuePercent) / 10) * 2 - 18;

      return `#${this.id}::-moz-range-track{background-size:${this.valuePercent}% 100%}
#${this.id}::-ms-track{background-size:${this.valuePercent}% 100%}
#${this.id}::-webkit-slider-runnable-track{background-size:${this.valuePercent}% 100%}
#${this.id}-value{left:${this.valuePercent}%;margin-left:${offset}px`;
    },
    valuePercent: function() {
      return Math.round(((this.value - this.min) * 100) / (this.max - this.min));
    },
  },
  mounted() {
    // provide a unique ID for DOM
    this.id = `${this.name}${this._uid}`.replace(/\W/, '');
    if (this.value === null) this.value = this.min;
  },
  unmount() {
    this.cancelTimers();
  },
  methods: {
    // @input, @change & @touch events are used for cross-browser support.
    // prevent duplicate events being sent to parent.
    change: function(event) {
      const value = Number(event.target.value);
      this.toggleTooltip();

      if (value !== this.sentValue) {
        this.$emit('change', [this.name, value]);
        this.sentValue = value;
      }
    },
    cancelTimers: function() {
      if (this.tooltipTimer !== null) {
        window.clearTimeout(this.tooltipTimer);
        this.tooltipTimer = null;
      }
    },
    hideTooltip: function() {
      this.cancelTimers();
      this.tooltipTimer = window.setTimeout(() => {
        document.getElementById(this.id + '-value').style.opacity = '0';
      }, 200);
    },
    showTooltip: function() {
      this.cancelTimers();
      document.getElementById(this.id + '-value').style.opacity = '1';
    },
    toggleTooltip: function() {
      this.cancelTimers();
      document.getElementById(this.id + '-value').style.opacity = '1';
      this.tooltipTimer = window.setTimeout(() => {
        document.getElementById(this.id + '-value').style.opacity = '0';
      }, 2000);
    },
  },
};
</script>
<template>
  <div :class="{'range-slider':true, active: isActive}" @mouseover="showTooltip()" @mouseout="hideTooltip()">
    <input :id="id"
           :name="name"
           :min="min"
           :max="max"
           :step="step"
           :value="value"
           type="range"
           class="range-slider__input"
           @input="change"
           @change="change">
    <output :id="`${id}-value`"><i></i><span>{{ value }}%</span></output>
    <v-style>{{ style }}</v-style>
  </div>
</template>
